// extracted by mini-css-extract-plugin
export default {"continueBtn":"AdvancedTheme_continueBtn__KF71-"};